import React from 'react';
import PropTypes from 'prop-types';
import _omit from 'lodash/omit';
import { Button } from '@material-ui/core';

const LinkButton = ({ children, label, underline, classes, ...props }) => {
  const root = underline ? classes.underline : classes.root;

  return (
    <Button color="primary" classes={{ root, ..._omit(classes, ['root', 'underline']) }} {...props}>
      {label || children}
    </Button>
  );
};

LinkButton.propTypes = {
  children: PropTypes.node,
  underline: PropTypes.bool,
  classes: PropTypes.objectOf(PropTypes.string),
};

LinkButton.defaultProps = {
  children: 'Ok',
  underline: false,
  classes: {},
};

export default LinkButton;
